function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "author-???");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "author-???",
  stroke: "current",
  strokeWidth: 0,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("polygon", {
  id: "Path",
  points: "20 20 0 20 0 0 20 0"
}), React.createElement("path", {
  d: "M17.375,10 C17.375,12.2615605 16.3570413,14.285364 14.7543254,15.6382089 L16.4911165,17.375 L10,17.375 C7.96344999,17.375 6.11969999,16.549525 4.78508749,15.2149125 C3.45047499,13.8803 2.625,12.03655 2.625,10 C2.625,7.96344999 3.45047499,6.11969999 4.78508749,4.78508749 C6.11969999,3.45047499 7.96344999,2.625 10,2.625 C12.03655,2.625 13.8803,3.45047499 15.2149125,4.78508749 C16.549525,6.11969999 17.375,7.96344999 17.375,10 Z",
  id: "Combined-Shape",
  stroke: "current",
  strokeWidth: 2.5
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/author-comments-count.e1c67906.svg";
export { SvgComponent as ReactComponent };